/**
 * Custom Inventory Limits for Quick Add
 * This file adds inventory validation to quick-add buttons
 * Safe to keep during theme updates
 */

document.addEventListener('DOMContentLoaded', function() {
  // Monitor all quantity inputs for inventory limits
  const quantityInputs = document.querySelectorAll('quantity-input input[data-inventory-max]');
  
  quantityInputs.forEach(input => {
    const maxInventory = parseInt(input.getAttribute('data-inventory-max'));
    
    if (maxInventory) {
      // Enforce max on input change
      input.addEventListener('change', function() {
        if (parseInt(this.value) > maxInventory) {
          this.value = maxInventory;
        }
      });
      
      // Disable plus button when at max
      const plusButton = input.closest('quantity-input').querySelector('button[name="plus"]');
      
      const checkMaxQuantity = () => {
        const currentValue = parseInt(input.value) || 0;
        if (currentValue >= maxInventory) {
          plusButton.setAttribute('disabled', 'disabled');
          plusButton.setAttribute('aria-disabled', 'true');
        } else {
          plusButton.removeAttribute('disabled');
          plusButton.removeAttribute('aria-disabled');
        }
      };
      
      // Check on load and on every change
      checkMaxQuantity();
      input.addEventListener('input', checkMaxQuantity);
      input.addEventListener('change', checkMaxQuantity);
    }
  });
});
